import { externalFormsApi } from 'api/externalForms'
import { ContentBlockTypes } from 'api/landingPageTheme'
import ModalContainer from 'components/ModalContainer'
import Spinner from 'components/Spinner'
import React from 'react'
import { useAvailableContentBlockTypes } from 'scenes/Cms/Content/AppHomePage/hooks'
import { AppLandingPageTheme } from 'slices/appLandingPageTheme/types'
import Block from './Block'

type Props = {
  isOpen: boolean
  onClose: () => void
  onAddNewBlock: (type: ContentBlockTypes) => void
  contentBlocks: AppLandingPageTheme['contentBlocks']
  blockOrder: Array<string>
}
const multipleAllowedBlockTypes: ContentBlockTypes[] = [
  'featured_content',
  'external_form',
  'personalized_text',
  'game',
  // Note: featured_content_carousel currently is limited to one by the back-end; This is because
  //       whenever a featured content carousel block is created (new) and it has slides
  //       we have no way of directly correlating the slides to the carousel, i.e. source_id would be nil
  //       Instead, we will just use the first carousel on the back-end
]

const AddNewBlockModal = ({
  isOpen,
  onClose,
  onAddNewBlock,
  contentBlocks,
  blockOrder,
}: Props) => {
  const {
    availableTypes,
    isLoading: isAvailableContentBlockLoading,
    gameContentBlocksAvailable,
  } = useAvailableContentBlockTypes()
  const currentBlockTypes = blockOrder.map(
    blockId => contentBlocks[blockId].type
  )

  const { data: formResponse, isLoading: isExternalFormsLoading } =
    externalFormsApi.useGetExternalFormsQuery()
  const forms = formResponse?.external_forms || []

  return (
    <ModalContainer
      title={'Add a new block'}
      isOpen={isOpen}
      onClose={onClose}
      showBottomProceed={false}
      dialogStyle={{ marginTop: '70px' }}
      zIndex={1000}
    >
      <Spinner
        isLoading={isAvailableContentBlockLoading || isExternalFormsLoading}
        size="2x"
        className="text-center mt-xxl"
      >
        {availableTypes.map(type => {
          const isDisabled =
            currentBlockTypes.includes(type) &&
            !multipleAllowedBlockTypes.includes(type)
          const unavailable =
            (type === 'external_form' && forms.length === 0) ||
            (type === 'game' && !gameContentBlocksAvailable)

          return (
            <Block
              key={type}
              type={type}
              isDisabled={isDisabled}
              onAddNewBlock={onAddNewBlock}
              unavailable={unavailable}
            />
          )
        })}
      </Spinner>
    </ModalContainer>
  )
}

export default AddNewBlockModal
